import { useMemo } from 'react';
import { OnboardingStepKeyEnum } from '../../../components/Onboarding';
import AboutWorkItemsModal from './AboutWorkItemsModal';
import { Guider, GuiderStepConfig } from '../../../shared/molecules/Guider/Guider';

export function OnboardingProjects() {
  // Define steps
  const steps: GuiderStepConfig[] = useMemo(
    () => [
      {
        key: "about_workitem",
        divId: '[data-onboarding-id="work-item-header"]',
        renderModal: ({ isOpen, onClose }) => (
          <AboutWorkItemsModal 
            isOpen={isOpen} 
            onClose={onClose} 
          />
        ),
        placement: "bottom" as const,
      },
      {
        key: "about_page",
        divId: '[data-onboarding-id="work-item-header"]',
        message: "All imported and created Epics and Features appear here",
        placement: "bottom",
      },
      {
        key: "create_project",
        divId: '[data-onboarding-id="create-project-btn"]',
        message: "Create new work item here. Please note import button too.",
        placement: "bottom",
      },
      {
        key: "filters",
        divId: '[data-onboarding-id="project-filters"]',
        message:
          "Use filters to find Epics and Features by status, quarter or source (e.g. Jira/Azure etc.).",
        placement: "bottom",
      },

      // {
      //   key: 'risk_awareness',
      //   getDiv: getAtRiskCard,
      //   condition: () => hasAtRiskRoadmaps,
      //   message: (ctx) => `${ctx.entityName ? `"${ctx.entityName}"` : 'This item'} is At Risk. Let's investigate why.`,
      //   onNext: async (ctx) => {
      //     if (ctx.entityId && JWTdata?.org_role === 'admin') {
      //        window.dispatchEvent(new CustomEvent('cadence:risk-open', { detail: { id: ctx.entityId } }));
      //     }
      //   }
      // },
      // {
      //   key: 'risk_analyze',
      //   waitFor: async () => waitForAnalyzeButtonVisible(context.entityId),
      //   condition: () => hasAtRiskRoadmaps && !!context.entityId,
      //   message: "Click 'Analyse Deeper' to open detailed risk analysis.",
      //   onNext: async (ctx) => {
      //     // Open Chat with prefill
      //     const prompt = `Analyse why @${ctx.entityName} is at risk? Provide actionable recommendations to mitigate the risk.`;

      //     setChatPrefill({
      //       type: 'strategy_map' as any,
      //       id: String(ctx.entityId || ''),
      //       name: ctx.entityName,
      //       fullPrompt: prompt,
      //       source: 'risk_mitigation' as any
      //     } as ChatPrefill);

      //     dispatch(resetAllChatsStreaming());
      //     dispatch(setIsNewChat(true));
      //     dispatch(setLastActiveChatId(null));
      //     dispatch(setShowChatbox(true));
      //     window.dispatchEvent(new CustomEvent('cadence:chat-prefill', {
      //       detail: {
      //         type: 'strategy_map',
      //         id: String(ctx.entityId || ''),
      //         name: ctx.entityName,
      //         fullPrompt: prompt,
      //         source: 'risk_mitigation'
      //       }
      //     }));
      //   }
      // },
      // {
      //     key: 'ai_prefill',
      //     waitFor: async () => waitForChatInput(),
      //     condition: () => hasAtRiskRoadmaps && !!context.entityId,
      //     message: "Here's a prefilled mitigation prompt. Adjust if needed.",
      //     placement: 'top'
      // }
    ],
    [],
  );

  return (
    <Guider
      onboardingKey={OnboardingStepKeyEnum.Explore}
      steps={steps}
      onCompleteSettingsKey="explore"
    />
  );
}